import React, { Fragment, useState, useEffect } from 'react'
import classNames from 'classnames'
import classes from './Plans.module.css'
import gridClasses from '../../styles/grid.module.css'
import { Header } from '../../components/Header/Header'
import {
    Hero,
    HeroContent,
    HeroTitle,
    HeroSubtitle,
} from '../../components/Hero/Hero'
import Footer from '../../components/Footer/Footer'
import PlansFaq from '../../components/Accordions/PlansFAQ'
import { IndividualPlans } from '../../components/Plans/IndividualPlans'

const PlanSection = () => {
    return (
        <div
            className={classNames(
                classes.infoSection,
                classes.infoSectionCentered
            )}
        >
            <IndividualPlans />
        </div>
    )
}

const FAQS = [
    {
        question: 'What are loyalty points?',
        answer:
            'Loyalty points are BONUS POINTS which could be applied as coupons on the purchase of a course or when you remain engaged with us on our social media platforms, including our blog.',
    },
    {
        question: 'How do I get loyalty points?',
        answer:
            'There are multiple ways to acquire loyalty points. It can be gifted to you as a loyal subscriber, when you interact with us on our social media platforms, through purchasing a course or participating in any of our offline or online activities..',
    },
    {
        question: 'What is the value of Loyalty Points?',
        answer:
            '1 loyalty points is equals to 1N. You can accumulate a number of loyalty points and then use it as discounts when buying a course or apply it as a one-off payment on a course if the value is equivalent to the amount for that course.',
    },
    {
        question: 'Do I get a lifetime access to the courses after payment?',
        answer: 'Yes, you get a lifetime access to every course you BUY.',
    },
    {
        question: 'How many courses can I get using my loyalty points?',
        answer:
            'Depending on the loyalty points given, you can redeem the point as coupons on a number of courses or one-off payment on a particular course if the value is equivalent to the amount for that course.',
    },
    {
        question: 'Do I get business templates when I purchase a course?',
        answer:
            'Yes. You would not only get templates, but also worksheets, canvas, flow diagrams and because our courses are step by step, you would have the opportunity to experience the hands on and practicality on how to implement what you have learnt.',
    },
    {
        question: 'How many staff does my business subscription plan cover?',
        answer:
            'Depending on the plan you have selected, each plan has a range of employees you can add to it as beneficiaries.',
    },
    {
        question: 'What happens when I cancel my business subscription plan?',
        answer:
            'When you cancel a subscription, automatically all FREE courses added to your plan will be removed. You will no longer have access to all the additional benefits anymore. Also, added beneficiaries would not have access to the FREE courses initially allotted to the account. This means that you will have to begin the process of accumulation again, when you re-subscribe.',
    },
    {
        question:
            "How can I get an extra course, even after I've selected the allotted FREE COURSES for the month for a business account?",
        answer:
            'To get an extra course, you would have to buy that course independently.',
    },
    {
        question: 'How many courses do I get for my individual subscription?',
        answer:
            'Depending on the plan, the minimum you can get is ONE FREE COURSE during your subscription. For instance if you select a higher plan you may be entitled to two or more courses.',
    },
    {
        question: 'What happens when I cancel my individual subscription plan?',
        answer:
            'When you cancel a subscription, automatically all FREE courses and every other benefits added to your plan will be removed. You will have to begin the process accumulation again, when you re-subscribe.',
    },
]

const FAQSection = () => {
    return (
        <div className={classes.faqSection}>
            <div className={gridClasses.container}>
                <div
                    className={classNames(
                        classes.infoSection,
                        classes.infoSectionDual
                    )}
                >
                    <div className={classes.infoSectionPane}>
                        <h1
                            className={classNames(
                                classes.infoSectionTitle,
                                classes.infoSectionTitleDecorated
                            )}
                        >
                            Frequently asked questions
                        </h1>
                    </div>
                    <div className={classes.infoSectionPane}>
                        {FAQS.map(faq => (
                            <div className={classes.faqItem}>
                                <PlansFaq
                                    header={faq.question}
                                    content={faq.answer}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export const PlansPage = () => {
    return (
        <Fragment>
            <Hero header={<Header />}>
                <HeroContent centered>
                    <HeroTitle>Pricing that works for everybody....</HeroTitle>
                    <HeroSubtitle>
                        Whether you are a professional trying to learn a
                        particular skill, an entrepreneur looking to learn
                        growth strategies, or even a business looking for
                        business growth support, we have prices that fit your
                        specific needs.
                    </HeroSubtitle>
                </HeroContent>
            </Hero>
            <div className={classes.content}>
                <div className={gridClasses.container}>
                    <PlanSection />
                </div>
            </div>
            <FAQSection />
            <Footer />
        </Fragment>
    )
}
